// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hVW4","content":"styles_content__2r-Zf"};